import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'en-US', // 语言标识
  // 'zh-CN', 'en-US', 'pt-PT', 'it-IT'
  messages: {
    'en-US': require('../static/lang/en1.json'),
    // 'zh-CN': require('@/assets/lang/zh-CN.json'),
    // 'zh-CN': require('@/assets/lang/zh-CN.json'),
    // 'zh-CN': require('@/assets/lang/zh-CN.json'),
  }
})
export default i18n



//////////////////
// WEBPACK FOOTER
// ./src/i18n.js
// module id = null
// module chunks = 